<template>
    <div>
        <v-row>
            <v-col cols="6">
                <gmap-map
                    ref="map"
                    id="map"
                    :zoom="16"
                    style="width: 100%; height: 500px"
                >
                </gmap-map>
            </v-col>
            <v-col cols="6">
                <gmap-map
                    ref="pano"
                    id="pano"
                    :zoom="16"
                    style="width: 100%; height: 500px"
                >
                </gmap-map>
            </v-col>
        </v-row>
    </div>
</template>

<script>
// import DirectionsRenderer from "./components/DirectionsRenderer"
export default {
    mounted() {
        setTimeout(() => {
            this.initialize()
        }, 1500)
    },
    methods: {
        initialize() {
            const fenway = { lat: 13.7274812, lng: 100.5401837 }
            const map = new google.maps.Map(document.getElementById("map"), {
                center: fenway,
                zoom: 14,
            })
            const panorama = new google.maps.StreetViewPanorama(
                document.getElementById("pano"),
                {
                    position: fenway,
                    pov: {
                        heading: 34,
                        pitch: 10,
                    },
                }
            )
            map.setStreetView(panorama)
        },
    },
    data() {
        return {
            term: "",
        }
    },
}
</script>
